<template>
  <footer>
      <!-- <div class="content" v-if="CONFIGS.LOGO_CLIENTE">
          <div class="logo">
              <img :src="CONFIGS.LOGO_CLIENTE" alt="Logo">
          </div>
      </div> -->
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  data() {
    return {}
  },
  computed: {
    ...mapGetters(["CONFIGS"]),
  },
  methods: {}
};
</script>

<style scoped>
</style>